import Close from '@mui/icons-material/Close';
import Launch from '@mui/icons-material/Launch';
import { IconButton, Stack } from '@mui/material';

type HeaderButtons = {
  LinkComponent?: React.ElementType;
  url?: string;
  handleClick?: () => void;
};

type QuickViewHeaderProps = HeaderButtons & {
  NavigateButtons?: React.ReactNode;
  handleClose: () => void;
};

const HeaderButton = ({ handleClick, url, LinkComponent }: HeaderButtons) => {
  if (handleClick) {
    return (
      <IconButton
        sx={{ alignSelf: 'flex-end' }}
        size="small"
        id="1"
        color="primary"
        onClick={handleClick}
        aria-label="expand"
      >
        <Launch htmlColor="text.secondary" fontSize="small" />
      </IconButton>
    );
  }

  if (url) {
    return (
      <IconButton
        sx={{ alignSelf: 'flex-end' }}
        size="small"
        id="1"
        color="primary"
        LinkComponent={LinkComponent}
        href={url}
        aria-label="expand"
      >
        <Launch htmlColor="text.secondary" fontSize="small" />
      </IconButton>
    );
  }

  return null;
};

export const QuickViewHeader = ({
  handleClose,
  NavigateButtons,
  LinkComponent,
  handleClick,
  url,
}: QuickViewHeaderProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      py="11px"
      pr="32px"
      pl="16px"
      sx={(theme) => ({ borderBottom: `1px solid ${theme.palette.divider}` })}
    >
      {NavigateButtons}
      <Stack direction="row" marginLeft="auto">
        <HeaderButton
          handleClick={handleClick}
          url={url}
          LinkComponent={LinkComponent}
        />
        <IconButton
          sx={{ alignSelf: 'flex-end' }}
          size="small"
          id="1"
          onClick={handleClose}
          aria-label="close"
        >
          <Close htmlColor="text.primary" fontSize="small" />
        </IconButton>
      </Stack>
    </Stack>
  );
};
